<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Homepage Components</h2>
        <p>Add new or drag and drop to re-order appearance of homepage components.</p>
      </v-flex>
      <v-flex xs12 md6 px-0 pb-4 mb-2>
        <v-list>
          <draggable style="width: 100%;" v-model="homepageOrderItems" :ghost="true">
            <v-list-tile v-for="(item, index) in homepageOrderItems" :key="index" class="drag-drop-list-item ml-0 mb-2 rounded-3">
              <v-icon color="secondary">swap_vert</v-icon>
              <v-list-tile-content class="ma-0 pa-0">
                <div style="position:relative; width:100%;">
                  <h3 class="ml-2 text-truncate" style="padding-right:80px">
                    {{ item.label }}
                  </h3>
                </div>
              </v-list-tile-content>
              <v-btn @click="deleteLayoutItem(item.id)" style="position:absolute; z-index:9; right:3px; top:0px" icon>
                <v-icon color="error">cancel</v-icon>
              </v-btn>
            </v-list-tile>
          </draggable>
        </v-list>
        <v-menu offset-y top origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ml-0" style color="secondary">Add new component</v-btn>
          </template>
          <v-flex v-for="component in componentList" :key="component.value">
            <v-list two-line>
              <v-list-tile
                @click="
                  currentType = component.value
                  createLayoutItem()
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <h3>{{ component.text }}</h3>
                  </v-list-tile-title>
                  <p class="ma-0">{{ component.description }}</p>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
          </v-flex>
          <v-list two-line>
            <v-list-tile
              @click="
                teamTasksSelectDialog = true
                currentType = 'teamTasks'
              "
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <h3>Team Tasks</h3>
                </v-list-tile-title>
                <p class="ma-0">Adds tasks assigned to a specific team</p>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list two-line>
            <v-list-tile
              @click="
                bucketGroupSelectDialog = true
                currentType = 'bucketGroup'
              "
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <h3>Bucket group</h3>
                </v-list-tile-title>
                <p class="ma-0">Adds all buckets from a specific group</p>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-dialog v-model="bucketGroupSelectDialog" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-3">
            <h2>Select a bucket group</h2>
          </v-card-title>
          <v-flex xs12>
            <v-autocomplete v-model="bucketGroupSelected" item-text="name" item-value="id" box label="Select a team bucket group" :items="bucketGroups" id="two-lines">
              <template v-slot:item="data">
                <template>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <h3>{{ data.item.name }} - {{ data.item.count }}</h3>
                    </v-list-tile-title>
                    <p v-html="data.item.desc"></p>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-card-actions class="ma-0 pa-0 pt-0">
            <v-btn :disabled="bucketGroupSelected === ''" @click="createLayoutItem()" color="success" class="mt-0">Confirm</v-btn>
            <v-btn @click="bucketGroupSelectDialog = false" color="secondary" class="mt-0">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="teamTasksSelectDialog" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-3">
            <h2>Select a team</h2>
          </v-card-title>
          <v-flex xs12>
            <v-autocomplete v-model="teamSelected" item-text="displayName" item-value="id" box label="Select a team" :items="teams" id="two-lines">
              <template v-slot:item="data">
                <template>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <h3>{{ data.item.displayName }}</h3>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-card-actions class="ma-0 pa-0 pt-0">
            <v-btn :disabled="bucketGroupSelected === ''" @click="createLayoutItem()" color="success" class="mt-0">Confirm</v-btn>
            <v-btn @click="teamTasksSelectDialog = false" color="secondary" class="mt-0">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import draggable from "vuedraggable"

export default {
  name: "acccount-layout",
  components: { draggable },
  data: () => {
    return {
      componentList: [{ text: "Case History", value: "caseHistory", description: "Adds a list of recently visited cases." }, { text: "Notifications", value: "notifications", description: "Adds user notifications." }, { text: "My Tasks", value: "tasks", description: "Adds tasks reporting panel." }],
      currentType: "",
      nonGroupSelectDialog: false,
      bucketGroupSelectDialog: false,
      bucketGroupSelected: null,
      teamSelected: null,
      teamTasksSelectDialog: null,
      newLayoutName: "",
    }
  },
  computed: {
    ...mapState({
      caseTypes: (state) => state.caseTypes.all,
      teams: (state) => state.teams.all,
      screenLayouts: (state) => (state && state.accounts && state.accounts.screenLayouts ? state.accounts.screenLayouts : []),
    }),
    bucketGroups() {
      const allGroups = []
      this.caseTypes.forEach((caseType) => {
        if (caseType.bucketGroups && caseType.bucketGroups.length > 0) {
          allGroups.push({ header: caseType.displayName })
          allGroups.push(...caseType.bucketGroups)
        }
      })
      return allGroups
    },
    homepageOrderItems: {
      get() {
        if (this.screenLayouts) {
          return this.orderLayouts()
        } else {
          return []
        }
      },
      set(input) {
        // Only used for re-ordering items
        if (input && this.screenLayouts && input.length === this.screenLayouts.length) {
          for (let i = 0; i < input.length; i++) {
            input[i].position = i
            if (input[i] !== this.screenLayouts[i]) {
              this.$store.dispatch("updateScreenLayoutItem", { id: input[i].id, position: i })
            }
          }
          this.$store.commit("setScreenLayouts", input)
        }
      },
    },
  },
  methods: {
    orderLayouts() {
      if (this.screenLayouts && this.screenLayouts.length > 0) {
        return this.screenLayouts.sort(function(a, b) {
          if (a.position < b.position) {
            return -1
          }
          if (a.position > b.position) {
            return 1
          }
          return 0
        })
      }
      return []
    },
    isDuplicate() {
      let result = false
      this.screenLayouts.forEach((layout) => {
        if (layout.label === this.newLayoutName) {
          result = true
        }
      })
      return result
    },
    async createLayoutItem() {
      if (this.currentType === "bucketGroup") {
        this.bucketGroups.forEach((group) => {
          if (group.id === this.bucketGroupSelected) {
            this.newLayoutName = group.name
          }
        })
      } else if (this.currentType === "teamTasks") {
        const team = this.teams.find((t) => t.id === this.teamSelected)
        this.newLayoutName = `${team.displayName} Tasks`
      } else {
        switch (this.currentType) {
          case "caseHistory":
            this.newLayoutName = "Case History"
            break
          case "notifications":
            this.newLayoutName = "Notifications"
            break
          case "tasks":
            this.newLayoutName = "My Tasks"
            break
        }
      }
      if (this.isDuplicate()) {
        if (this.currentType === "bucketGroup") {
          this.newLayoutName = "Bucket Group"
        }
        this.$store.commit("displayFlashMessage", { message: "Cannot add duplicate " + this.newLayoutName + " component!", severity: "error" })
      } else {
        await this.$store.dispatch("createScreenLayoutItem", { type: this.currentType, label: this.newLayoutName, bucketGroupId: this.bucketGroupSelected, position: this.screenLayouts.length, teamId: this.teamSelected })
      }
      this.resetLayoutData()
    },
    async deleteLayoutItem(id) {
      await this.$store.dispatch("deleteScreenLayoutItem", { id: id })
    },
    resetLayoutData() {
      this.nonGroupSelectDialog = false
      this.bucketGroupSelectDialog = false
      this.teamTasksSelectDialog = false
      this.currentType = ""
      this.newLayoutName = ""
      this.bucketGroupSelected = null
      this.teamSelected = null
    },
  },
}
</script>

<style>
.v-menu__content {
  z-index: 1000 !important;
}
</style>
